import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authChildGuard, authGuard, authMatchGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    canMatch: [authMatchGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
